import {useBoolean} from '../../../../../hooks/useSlice'
import {defaultBranch} from '../../../../../utils/branchNames'
import Popup from '../../../../common/Popup/Popup.lazy'
import SequenceLoader from '../../../../common/SequenceLoader/SequenceLoader'
import ChangesPreview from '../../ChangesPreview/ChangesPreview.container'
import PendingChangesPreview from '../../ChangesPreview/PendingChangesPreview.container'

import {POPUP_DIRECTIONS, VISIBLE_CHANGES} from './ChangesDropdownContent.constants'
import type {Props} from './ChangesDropdownContent.types'

import styles from './ChangesDropdownContent.css'

function ChangesDropdownContent({
  buildId,
  buildTypeId,
  branch,
  changesCount,
  isPending,
  hidden,
  ...otherProps
}: Props) {
  const [isExpanded, onShowChangeDetails, onHideChangeDetails] = useBoolean(false)
  const isHidePopup = isExpanded ? false : hidden

  const commonProps = {
    className: styles.changes,
    visibleCount: VISIBLE_CHANGES,
    buildTypeId,
    onShowChangeDetails,
    onHideChangeDetails,
  }

  if (isHidePopup || (!isPending && buildId == null)) {
    return null
  }

  return (
    <Popup hidden={isHidePopup} directions={POPUP_DIRECTIONS} {...otherProps}>
      <div className={styles.content} data-test-changes-popup={'content'}>
        <SequenceLoader>
          {isPending === true ? (
            <PendingChangesPreview
              {...commonProps}
              seqKey="ChangesAdvancedView"
              branch={branch == null ? defaultBranch : branch}
              changesCount={changesCount}
            />
          ) : (
            <ChangesPreview
              {...commonProps}
              seqKey="ChangesAdvancedView"
              branch={branch}
              buildId={buildId}
            />
          )}
        </SequenceLoader>
      </div>
    </Popup>
  )
}

export default ChangesDropdownContent
